'use client';

import React, { type FC } from 'react';
import { formatCreditsNumber } from '../utils/formatters';
import { IoTicket } from './icons';

interface BandTicketsProps {
  amount: number;
  className?: string;
  showIcon?: boolean;
  iconSize?: number;
  iconOnly?: boolean;
  muted?: boolean;
}

export const BandTickets: FC<BandTicketsProps> = ({ amount, className, showIcon = true, iconSize = 12, iconOnly = false, muted = false }) => {
  return (
    <span className={`inline-flex items-center gap-1 ${className || ''}`}>
      {!iconOnly && formatCreditsNumber(amount)}
      {showIcon && <IoTicket className={muted ? 'text-accent-blue/50 shrink-0' : 'text-accent-blue shrink-0'} size={iconSize} />}
    </span>
  );
};
